export default __webpack_public_path__ + "static/media/F0003.89b83bbf.png";